import React from 'react';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function About() {
  useSeo(
    'About Rev-Tech | Cybersecurity & IT Services',
    'Learn about Rev-Tech leadership, mission, and our approach to managed IT, cybersecurity consulting, and technical project delivery.',
    {
      ogTitle: 'About Rev-Tech | Cybersecurity & IT Services',
      ogDescription: 'Learn about Rev-Tech leadership, mission, and our approach to managed IT, cybersecurity consulting, and technical project delivery.',
      twitterTitle: 'About Rev-Tech | Cybersecurity & IT Services',
      twitterDescription: 'Learn about Rev-Tech leadership, mission, and our approach to managed IT, cybersecurity consulting, and technical project delivery.',
      canonical: 'https://www.rev-technology.com/about'
    }
  );

  return (
    <div className="page">
      <section className="hero">
        <h1>About Rev-Tech</h1>
        <p className="hero-copy">
          Rev-Tech delivers managed services, cybersecurity consulting, and technical project support for clients across the United States.
          We help businesses reduce risk, improve performance, and meet compliance needs with expert guidance and execution.
        </p>
      </section>

      <section className="content-section">
        <h2>Our Story</h2>
        <p>
          Rev-Tech was founded to provide modern IT and cybersecurity support without geographic limits.
          We partner with companies that need smart technology management, strong security posture, and trusted technical expertise.
        </p>
      </section>

      <section className="content-section">
        <h2>Our Mission</h2>
        <p>
          We deliver proactive IT management, responsive support, and strategic guidance that simplifies complexity and strengthens operational resilience. Through transparency, expertise, and a commitment to long‑term partnership, we ensure our clients can focus on what matters most, growing their business with confidence.
        </p>
      </section>

      <section className="content-section">
        <h2>Our Values</h2>
        <ul className="values-list">
          <li><strong>Integrity:</strong> We act transparently and ethically in every engagement.</li>
          <li><strong>Excellence:</strong> We deliver quality solutions with precision and care.</li>
          <li><strong>Client Focus:</strong> We tailor our services to your business goals and challenges.</li>
          <li><strong>Innovation:</strong> We embrace new technology and smarter ways of working.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Meet the Founders</h2>
        <p>
          Our leadership team combines deep technical experience with a practical approach to cybersecurity,
          managed services, and mission-critical project work.
        </p>
        <div className="team-grid">
          <div className="team-card">
            <div className="team-image">
              <img src="/images/team/luke.jpg" alt="Luke Tefoe" />
            </div>
            <h3>Luke Tefoe</h3>
            <p><strong>Co-Founder</strong></p>
            <div className="team-summary">
              <p>
                Strategic leader focused on aligning business goals with secure technology solutions.
                Drives managed services strategy, cybersecurity direction, and client engagement.
              </p>
            </div>
            <div className="team-detail-block">
              <h4>Credentials</h4>
              <ul>
                <li>Certified Information Systems Security Professional (CISSP)</li>
                <li>CompTIA SecurityX</li>
                <li>M.S. Cybersecurity and Information Assurance</li>
              </ul>
            </div>
            <div className="team-detail-block">
              <h4>Experience</h4>
              <ul>
                <li>10+ years in cybersecurity leadership and managed services</li>
                <li>Broad tech experience, from networking to low level development</li>
                <li>United States Marine Corps Veteran</li>
              </ul>
            </div>
          </div>
          <div className="team-card">
            <div className="team-image">
              <img src="/images/team/justin.jpg" alt="Justin Buck" />
            </div>
            <h3>Justin Buck</h3>
            <p><strong>Co-Founder</strong></p>
            <div className="team-summary">
              <p>
                Technical director with deep expertise in cybersecurity implementations and project delivery.
                Leads secure infrastructure builds, compliance projects, and technical consulting engagements.
              </p>
            </div>
            <div className="team-detail-block">
              <h4>Credentials</h4>
              <ul>
                <li>CompTIA Security+ certified</li>
                <li>Certified in Governance, Risk and Compliance (CGRC)</li>
              </ul>
            </div>
            <div className="team-detail-block">
              <h4>Experience</h4>
              <ul>
                <li>8+ years building secure environments meeting compliance requirements</li>
                <li>Delivered multiple DoD readiness and audit support engagements</li>
                <li>United States Air Force Veteran</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
